<template>
  <aside class="gp-sidebar" :class="{ 'gp-sidebar-open': isOpen }">
    <router-link to="/Home" class="gp-sidebar-brand" @click="closeMobile">
      <img :src="displayLogoUrl" alt="Logo da garantidora" @error="handleLogoError" />
    </router-link>

    <nav class="gp-sidebar-nav">
      <div class="gp-nav-label">Navegação</div>
      <router-link class="gp-nav-link" to="/Home" title="Painel executivo" @click="closeMobile">
        <i class="fas fa-home"></i><span>Painel executivo</span>
      </router-link>

      <section v-for="grupo in gruposComTelas" :key="grupo.grtId" class="gp-nav-section">
        <button
          type="button"
          class="gp-nav-group-button"
          :class="{ 'gp-nav-group-active': grupoAtivo(grupo.grtId) }"
          :aria-label="grupo.grtNome"
          :title="grupo.grtNome"
          :aria-expanded="grupoAberto(grupo.grtId)"
          @click="toggleGrupo(grupo.grtId)"
        >
          <v-icon size="19">{{ grupo.grtIcon || 'mdi-folder-outline' }}</v-icon>
          <span>{{ grupo.grtNome }}</span>
          <v-icon class="gp-nav-chevron" size="17">
            {{ grupoAberto(grupo.grtId) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
          </v-icon>
        </button>

        <div v-show="grupoAberto(grupo.grtId)" class="gp-nav-submenu">
          <router-link
            v-for="tela in telasDoGrupo(grupo.grtId)"
            :key="tela.cdtId"
            class="gp-nav-link gp-nav-sublink"
            :to="tela.cdtUrl"
            :title="tela.cdtNome"
            @click="closeMobile"
          >
            <v-icon size="18">{{ tela.cdtIcon || 'mdi-circle-small' }}</v-icon>
            <span>{{ tela.cdtNome }}</span>
          </router-link>
        </div>
      </section>
    </nav>

    <button v-if="assistenteVirtualDisponivel" type="button" class="gp-sidebar-support" @click="supportDialog = true">
      <span class="gp-support-icon"><v-icon size="22">mdi-robot-outline</v-icon></span>
      <span class="gp-support-copy">
        <small>Assistente virtual</small>
        <strong>Suporte GarantePay</strong>
      </span>
      <v-icon class="gp-support-arrow" size="17">mdi-chevron-right</v-icon>
    </button>
  </aside>

  <v-dialog v-if="assistenteVirtualDisponivel" v-model="supportDialog" width="560">
    <div class="gp-support-dialog">
      <header class="gp-support-dialog-header">
        <span class="gp-support-dialog-icon"><v-icon size="25">mdi-robot-outline</v-icon></span>
        <div>
          <small>Assistente de IA</small>
          <h3>Suporte GarantePay</h3>
        </div>
        <button type="button" aria-label="Fechar" @click="supportDialog = false">
          <v-icon size="20">mdi-close</v-icon>
        </button>
      </header>

      <div class="gp-support-conversation">
        <div class="gp-support-welcome">
          <v-icon size="22">mdi-message-text-outline</v-icon>
          <strong>Como podemos ajudar?</strong>
          <span>Em breve você poderá enviar perguntas e receber orientações do assistente GarantePay.</span>
        </div>
        <div class="gp-support-suggestions">
          <span>Dúvidas sobre cadastros</span>
          <span>Ajuda com contratos</span>
          <span>Orientações financeiras</span>
        </div>
      </div>

      <footer class="gp-support-composer">
        <input type="text" placeholder="Digite sua pergunta..." disabled />
        <button type="button" disabled title="Funcionalidade em breve">
          <v-icon size="19">mdi-send-outline</v-icon>
        </button>
      </footer>
      <div class="gp-support-soon"><v-icon size="14">mdi-information-outline</v-icon> Funcionalidade ilustrativa — disponível em breve.</div>
    </div>
  </v-dialog>
</template>

<script>
import authService from '../auth/oidc'

export default {
  name: 'PageHeader',
  data: () => ({
    isOpen: false,
    isCollapsed: false,
    assistenteVirtualDisponivel: false,
    supportDialog: false,
    User: null,
    Telas: [],
    GrupoTelas: [],
    gruposAbertos: {},
    imagemlogo: '',
    contextLogoUrl: authService.getActiveGuarantorLogoUrl(),
    rotasDisponiveis: [
      '/home', '/cadastrousuarios', '/controlepermissoesperfil', '/cadastrotipopessoas', '/clientes',
      '/cadastrotipousuario', '/grupotelas', '/controlesmtp', '/cadastrotipooperadora',
      '/cadastrotipodocumento', '/cadastrotipocliente', '/cadastrotelas', '/cadastroprodutosconsulta',
      '/planoscobertura', '/cadastroplanosgarantepay', '/cadastromodeloscontratos', '/cadastrolistaservicosextras',
      '/cadastrolistadocumento', '/cadastroformaspagamento', '/cadastroduvidasfrequentes',
      '/cadastrodocumentossinistros', '/cadastroavisosistema', '/cadastromensagenspadrao',
      '/segmentosprod', '/produtos', '/garantepay', '/controlecobrancasgarantepay',
      '/totalmensalprevistogarantepay', '/totalanualprevistogarantepay',
      '/controlecobrancas', '/totalanualcobranca', '/totalmensalcobranca', '/cobrancasimobiliarias', '/controlecobrancasimobiliarias', '/garantidoras', '/recargaconsultas', '/imobiliarias', '/parceiros', '/contratacaodetalhe', '/contratacaonegadadetalhe', '/contratacaovigenciafinalizadadetalhe', '/contratacaovigentedetalhe', '/contratacoesnegadocancelado', '/listacontratacoes', '/listacontratacoesvigenciafinalizada', '/listacontratacoesvigentes', '/novacontratacao', '/novacontratacaogarantia', '/tombamentoplanilha', '/relatorioconcentracaocontratosativos', '/relatoriocontratosativos', '/relatoriocontratosavencer', '/relatoriocontratosencerrados', '/relatorioevolucaocarteira', '/relatorioprovisaosinistros', '/relatoriousoconsultasassinaturas', '/cadastrosinistros', '/listasinistrosacordoparcelas', '/listasinistrosacordo', '/listasinistrosaprovacao', '/listasinistroscobranca', '/listasinistrospagamento', '/listasinistros', '/sinistroacordodetalhe', '/sinistroaprovacaodetalhe', '/sinistrocobrancadetalhe', '/sinistropagamentodetalhe', '/cadastrochamados', '/chamadosandamento', '/suptiposchamados'
    ]
  }),
  computed: {
    displayLogoUrl () {
      if (this.contextLogoUrl) return this.contextLogoUrl
      if (this.imagemlogo) return this.buildFileUrl(this.imagemlogo)
      return '/images/logogarantepay.jpg'
    },
    gruposComTelas () {
      return this.GrupoTelas.filter(grupo => this.telasDoGrupo(grupo.grtId).length)
    }
  },
  watch: {
    '$route.path' () {
      const grupoAtual = this.GrupoTelas.find(grupo => this.grupoAtivo(grupo.grtId))
      if (grupoAtual) this.gruposAbertos[grupoAtual.grtId] = true
    }
  },
  methods: {
    toggleMobile () { this.isOpen = !this.isOpen },
    toggleCollapsed () {
      this.isCollapsed = !this.isCollapsed
      document.documentElement.classList.toggle('gp-layout-collapsed', this.isCollapsed)
      localStorage.setItem('gp-menu-collapsed', this.isCollapsed ? '1' : '0')
    },
    closeMobile () { this.isOpen = false },
    toggleGrupo (grupoId) {
      if (this.isCollapsed && window.matchMedia('(min-width: 992px)').matches) {
        this.gruposAbertos[grupoId] = true
        this.toggleCollapsed()
        return
      }
      this.gruposAbertos[grupoId] = !this.grupoAberto(grupoId)
    },
    grupoAberto (grupoId) {
      return this.gruposAbertos[grupoId] === true
    },
    grupoAtivo (grupoId) {
      const rotaAtual = this.$route.path.replace(/\/$/, '').toLowerCase()
      return this.telasDoGrupo(grupoId).some(tela => {
        const rotaTela = String(tela.cdtUrl).split('?')[0].replace(/\/$/, '').toLowerCase()
        return rotaTela === rotaAtual
      })
    },
    telasDoGrupo (grupoId) {
      return this.Telas
        .filter(tela => tela.admGrupoTelas?.grtId === grupoId && this.rotaEstaDisponivel(tela.cdtUrl))
        .sort((a, b) => a.cdtOrdem - b.cdtOrdem)
    },
    rotaEstaDisponivel (url) {
      if (!url) return false
      const path = String(url).split('?')[0].replace(/\/$/, '').toLowerCase()
      return this.rotasDisponiveis.includes(path)
    },
    buildFileUrl (path) {
      if (!path) return ''
      if (/^https?:\/\//i.test(String(path))) return String(path)
      const rel = String(path).replace(/\\/g, '/')
      return `${this.$imgURL}/Telas/Home/GetFileByParam?param=${encodeURIComponent(rel)}&t=${Date.now()}`
    },
    handleLogoError () {
      if (this.contextLogoUrl) {
        this.contextLogoUrl = null
        authService.clearActiveGuarantorLogoUrl()
        return
      }

      this.imagemlogo = ''
    },
    async loadGuarantorBrand () {
      this.contextLogoUrl = await authService.refreshActiveGuarantorBrand()
    }
  },
  created () {
    window.addEventListener('layout:toggle-menu', this.toggleMobile)
    window.addEventListener('layout:toggle-collapse', this.toggleCollapsed)
    this.isCollapsed = localStorage.getItem('gp-menu-collapsed') === '1'
    document.documentElement.classList.toggle('gp-layout-collapsed', this.isCollapsed)
    this.loadGuarantorBrand()
    const armazenado = localStorage.getItem('_useravgar')
    if (!armazenado) return

    try {
      this.User = JSON.parse(armazenado)
    } catch (error) {
      console.error('[GarantePay] Dados de sessão inválidos no menu.', error)
      localStorage.removeItem('_useravgar')
      this.$mensagemErro('Os dados da sessão ficaram inválidos. Entre novamente no sistema.')
      this.$router.push('/')
      return
    }
    const menuBackend = this.User?.menu || []
    console.log('[MENU BACKEND] Lista original recebida:', menuBackend)
    console.table(menuBackend.map(tela => ({
      cdtId: tela.cdtId,
      cdtNome: tela.cdtNome,
      cdtUrl: tela.cdtUrl,
      cdtOrdem: tela.cdtOrdem,
      cdtVisivel: tela.cdtVisivel,
      grtId: tela.admGrupoTelas?.grtId,
      grtNome: tela.admGrupoTelas?.grtNome,
      grtVisivel: tela.admGrupoTelas?.grtVisivel
    })))
    this.Telas = menuBackend.filter(tela => tela.cdtVisivel && tela.admGrupoTelas?.grtVisivel)
    console.log('[MENU FRONTEND] Lista após filtro de visibilidade:', this.Telas)
    console.table(this.Telas.map(tela => ({
      cdtId: tela.cdtId,
      cdtNome: tela.cdtNome,
      cdtUrl: tela.cdtUrl,
      grupo: tela.admGrupoTelas?.grtNome,
      rotaDisponivel: this.rotaEstaDisponivel(tela.cdtUrl)
    })))
    this.GrupoTelas = Array.from(
      new Map(this.Telas.map(tela => [tela.admGrupoTelas.grtId, tela.admGrupoTelas])).values()
    ).sort((a, b) => (a.grtOrdem - b.grtOrdem) || a.grtNome.localeCompare(b.grtNome))
    this.GrupoTelas.forEach(grupo => {
      this.gruposAbertos[grupo.grtId] = this.grupoAtivo(grupo.grtId)
    })
    this.imagemlogo = this.User?.garlogo || ''
  },
  beforeUnmount () {
    window.removeEventListener('layout:toggle-menu', this.toggleMobile)
    window.removeEventListener('layout:toggle-collapse', this.toggleCollapsed)
  }
}
</script>
